module.exports = __webpack_public_path__ + "media/images/flags/1x1/pri-192f36b314b67febf3f33f10d9a8afd6.svg";